export const DATABASE_NAME = 'real-maquinas-inspecao'
export const DATABASE_SCHEMA_VERSION = 10
export const LEGACY_INSPECTION_SCHEMA_VERSION = 4
export const INSPECTION_SCHEMA_VERSION = 6
